module.exports = __webpack_public_path__ + "img/effect_halloween_fire.af34edbc.png";